import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { NotifyPrefsCard } from "@/components/collector/NotifyPrefsCard";

export const AdminAlertSettings = () => {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/me/contact", { email, phone });
      setUser((u) => ({ ...u, ...data }));
      setEmail(data.email || "");
      setPhone(data.phone || "");
      toast.success("Alert contact saved");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-alert-settings">
      <form onSubmit={save} className="card-soft mb-4">
        <h2 className="font-heading text-xl text-[#1E3F33] mb-1 flex items-center gap-2"><BellRing className="w-4 h-4 text-[#CC5A3A]" /> Alert contact</h2>
        <p className="text-xs text-[#8A9A86] mb-4">Where we send admin alerts, like a customer request that found no matching collector.</p>
        <label className="text-sm text-[#1E3F33] font-medium">Email</label>
        <input data-testid="admin-alert-email-input" type="email" className="input-soft mt-1 mb-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
        <label className="text-sm text-[#1E3F33] font-medium">Mobile phone (SMS)</label>
        <input data-testid="admin-alert-phone-input" type="tel" className="input-soft mt-1 mb-4" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(555) 123-4567" />
        <button data-testid="admin-alert-save-btn" type="submit" disabled={saving} className="btn-primary text-sm py-2 px-4 disabled:opacity-50">{saving ? "Saving…" : "Save contact"}</button>
      </form>
      <NotifyPrefsCard
        prefs={user?.notify_prefs} email={user?.email} phone={user?.phone} endpoint="/me/notify-prefs"
        onSaved={(d) => setUser((u) => ({ ...u, ...d }))}
        title="No-match alert channels"
        desc="Choose how you're told when a request finds no collector offering the service nearby."
        testid="admin-alert-channels"
      />
    </div>
  );
};
